module.exports = __webpack_public_path__ + "img/maersk.3d91a368.png";